import styles from './styles.scss';
import Button from 'components/Shared/Button';
import cn from 'classnames';

interface SliderDotsProps {
  goToSlide: () => void;
  isActiveSlide: () => boolean;
  isAdjacentSlide: () => boolean;
}

export const SliderDots = ({ isActiveSlide, goToSlide, isAdjacentSlide }: SliderDotsProps) => (
  <Button appearance="clear" onClick={goToSlide}>
    <div
      className={cn(styles.sliderButton, {
        [styles.active]: isActiveSlide(),
        [styles.adjacent]: isAdjacentSlide()
      })}
    />
  </Button>
);
